/**
 * Root saga do módulo UI
 * Por enquanto vazio, pois toasts não precisam de side effects complexos
 */
export function* uiSaga() {
  // Se no futuro precisarmos de lógica assíncrona para UI, adicionar aqui
}

